import { createApp } from 'vue'
import App from './app.vue'
import { applyThemeMode } from './themePreference'

applyThemeMode()

createApp(App).mount('#app')
